<template>
  <section class="error-page">
    <div class="title-wrapper">
      <h1>404 | Not Found</h1>
    </div>
    <div class="content">
      <div class="description-wrapper">
        <p>
          お探しのページはみつかりませんでした。<br />
          <br />
          お探しのページは一時的にアクセスできない状況にあるか、<br />
          移動もしくは削除された可能性があります。
        </p>
      </div>
      <div class="navigation-wrapper">
        <a class="btn" @click="$router.go(-1)">前の画面へ戻る</a>
      </div>
    </div>
    <div class="content">
      <div class="description-wrapper">
        <p>
          開催時間になりましたら入場画面が表示されるようになります。
          <br />
          ご来場お待ちしております。
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "NotFound",
  mounted() {
    this.$store.commit("loading/setLoading", false)
  }
}
</script>
